import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CmsConfig, I18nModule, provideConfig, UrlModule} from '@spartacus/core';
import {GenericLinkModule, MediaModule} from '@spartacus/storefront';

import {AimoPipesModule} from '../utils/safe-html/aimo-pipes.module';

import {AimoSimpleBannerComponent} from './aimo-simple-banner.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        UrlModule,
        I18nModule,
        MediaModule,
        GenericLinkModule,
        AimoPipesModule,
    ],
    providers: [
        provideConfig(<CmsConfig>{
            cmsComponents: {
                AimoSimpleBannerComponent: {
                    component: AimoSimpleBannerComponent,
                },
            },
        }),
    ],
    declarations: [AimoSimpleBannerComponent],
    exports: [AimoSimpleBannerComponent],
})
export class AimoSimpleBannerModule {
}
